module.exports = __webpack_public_path__ + "img/关于宏邦1.cc3355ed.jpg";